module.exports = __webpack_public_path__ + "static/media/Main.0cd4c00a.png";